import { Component, AfterViewInit, OnDestroy, OnInit } from '@angular/core';
import * as c3 from 'c3';
import * as d3 from 'd3';
import { ChartDefinitionService } from '../../services/chart-definition.service';
import { FeatureFlagService } from '../../services/feature-flag.service';
import { MatDialog } from '@angular/material';
import { FeatureFlagDetailsComponent } from './feature-flag-details/feature-flag-details.component';

@Component({
  selector: 'app-feature-flag-widget',
  templateUrl: './feature-flag-widget.component.html',
  styleUrls: ['./feature-flag-widget.component.css']
})
export class FeatureFlagWidgetComponent implements OnInit, AfterViewInit, OnDestroy {

  public loading: boolean = true;
  public loadedDate: string = 'Current';

  private chart: c3.Chart;

  constructor(
    private featureFlagService: FeatureFlagService,
    private chartDefinitionService: ChartDefinitionService,
    public dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.chart = this.chartDefinitionService.featureFlagChart('#feature-flags', 200, 700);
  }

  ngAfterViewInit(): void {
    this.load();
  }

  ngOnDestroy(): void {
    if (this.chart && this.chart.destroy) {
      this.chart.destroy();
    }
    delete this.chart;
  }

  private load(): void {
    this.loading = true;
    this.loadData();
  }

  public viewDetails() {
    this.featureFlagService.getFeatureFlagStateDetails().subscribe(response => {
      if (response) {
        //   {
        //     'team': 'DevOps',
        //     'enabled': 8,
        //     'disabled': 15,
        //     'old': 5,
        //     'occurredOn': '2018-10-12 12:00:00 AM'
        //   },
        const data: any[] = Array.from(response as any);
        const teams = Array.from(new Set(data.map(m=>m.team)));
        const details = teams.map(team => {return {team: team.toUpperCase(), flags: data.filter(f=>f.team === team) }});
        this.dialog.open(FeatureFlagDetailsComponent, {
          data: {
            teams: details
          }
        });
      }
    })


  }

  private loadData(): void {
    this.featureFlagService.getFeatureFlagStateSummary().subscribe(response => {
      if (response) {
        //   {
        //     'team': 'DevOps',
        //     'enabled': 8,
        //     'disabled': 15,
        //     'old': 5,
        //     'loadedDate': '2018-10-12 12:00:00 AM'
        //   },
        const data: any[] = Array.from(response as any);
        this.loadedDate = data[0].loadedDate;
        
        const columns = [
          ['x', ...data.map(m=>m.team.toUpperCase())],
          ["data1", ...data.map(m=>m.enabled)],
          ["data2", ...data.map(m=>m.disabled)],
          ["data3", ...data.map(m=>m.old)]
        ];

        this.chart.load({columns: columns});
        this.loading = false;
      }
    })
  }

  private dataClickCallback (d, el) {
    const myThis = this;
    var vals = this.chart.data().map (function (series) {
        var name = series.id;
        return {
          name: name, 
          value: myThis.chart.data.values(name)[d.x],
          x: myThis.chart.data.names()[name]
        };
      }
    );
    console.log(JSON.stringify(vals));
  }
}
